import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { isHrEnabled } from '@/utils/hr'

const Navigation: React.FC = () => {
  const location = useLocation()
  const [hrEnabled, setHrEnabled] = useState<boolean>(isHrEnabled())
  const isActive = (path: string) => location.pathname === path

  // Listen for localStorage changes
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'isHr') {
        setHrEnabled(isHrEnabled())
      }
    }

    // Also listen for URL changes in case of back/forward navigation
    const handleUrlChange = () => {
      setHrEnabled(isHrEnabled())
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('popstate', handleUrlChange)

    // Initial check in case the component mounts after the URL changes
    setHrEnabled(isHrEnabled())

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('popstate', handleUrlChange)
    }
  }, [])

  return (
    <div className="nav-bar">
      <div className="container">
        <div className="nav-links">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
            <i className="fas fa-home" /> 首页
          </Link>
          <Link to="/maternity" className={`nav-link ${isActive('/maternity') ? 'active' : ''}`}>
            <i className="fas fa-baby" /> 个人产假计算
          </Link>
          <Link to="/allowance" className={`nav-link ${isActive('/allowance') ? 'active' : ''}`}>
            <i className="fas fa-money-bill-wave" /> 个人津贴补差
          </Link>
          {hrEnabled && (
            <Link to="/batch" className={`nav-link ${isActive('/batch') ? 'active' : ''}`}>
              <i className="fas fa-users" /> 批量处理
            </Link>
          )}
          <Link to="/history" className={`nav-link ${isActive('/history') ? 'active' : ''}`}>
            <i className="fas fa-history" /> 历史记录
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Navigation
